module.exports = "/_next/static/images/ourPartnersAlaskaTelecom-67f923c5ca3a914dcc38d30c82bb46ed.webp";